import React from 'react';
import styled from 'styled-components';
import { Text } from '@landr/maestro';

export interface LetterArtworkProps {
    name: string;
}

const TextNotSelectable = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 18%;

    user-select: none;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LetterArtwork: React.FC<LetterArtworkProps> = ({ name }) => {
    return (
        <TextNotSelectable>
            <Text size="jb" contrast="low">
                {name.charAt(0)}
            </Text>
        </TextNotSelectable>
    );
};

LetterArtwork.displayName = 'LetterArtwork';

export default LetterArtwork;
